<div class="container-fluid login-container">
  <div class="row align-items-center login-container-row">
    <div class="col-sm-4 col-lg-3 title-block d-none d-sm-block">
      One Stop Service for
      <div class="e-tax-title mt-2">E-TAX</div>
      <div class="e-tax-subtitle">Invoice & Receipt</div>
    </div>
    <div class="col-sm-8 col-lg-4 offset-lg-4 px-lg-5">
      <!-- <img src="../../assets/images/login-logo.png"> -->

      <div class="welcome-text mt-sm-4">Welcome</div>
      Please login to your account.

      <div class="form-group mt-2 mb-sm-2">
        <input class="form-control form-control-lg" id="username" name="username" placeholder="Username"
               type="text" [(ngModel)]="username" (keyup.enter)="login()">
      </div>
      <div class="form-group">
        <input class="form-control form-control-lg" id="password" name="password" placeholder="Password"
               type="password" [(ngModel)]="password" (keyup.enter)="login()">
      </div>

      <!--<div class="form-row">-->
        <!--<div class="col">-->
          <!--<div class="form-group mb-0">-->
            <!--<div class="form-check">-->
              <!--<input class="form-check-input" type="checkbox" value="true" id="remember">-->
              <!--<label class="form-check-label" for="remember">-->
                <!--Remember Me-->
              <!--</label>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
        <!--<div class="col text-right">-->
          <!--Forget Password?-->
        <!--</div>-->
      <!--</div>-->

      <div class="text-red text-center my-1 d-block">
        {{ errorMessage ? errorMessage : '&nbsp;' }}
      </div>

      <div class="form-group">
        <button class="btn btn-dv btn-wider" (click)="login()">
          Login
        </button>
      </div>

      <!-- <div class="float-right mt-sm-2 mt-lg-4">
        <div class="footer-text">Powered by</div>
        <img src="../../assets/images/logo.png">
      </div> -->
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/login/login.component.html